import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import useDispatch from 'hooks/useDispatch'
import { selectCurrentMerchant } from 'selectors/merchant'
import { resetForm } from 'slices/Cms/Settings/PostOrderFeedback'

export const usePostOrderFeedbackFormInitialize = () => {
  const dispatch = useDispatch()
  const merchant = useSelector(selectCurrentMerchant)
  // Key the effect on the merchant *identity* — not the full object reference —
  // so a successful PATCH (which invalidates the merchant cache and produces a
  // new object reference for the same merchant) does NOT trigger resetForm and
  // overwrite the user's in-progress edits to other fields. The body is also
  // idempotent (it would set the same value on the same merchant); the id-keyed
  // dep makes the no-op explicit. A real change in merchant identity (e.g.
  // switching accounts in admin) re-initializes correctly.
  const merchantId = merchant?.id

  useEffect(() => {
    if (merchant) {
      dispatch(
        resetForm({
          allowPostOrderFeedbackEmail:
            merchant.allow_post_order_feedback_email || false,
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantId, dispatch])
}
